export function showPage404 () {
  console.log('showPage404')

  document.getElementById('app-content').innerHTML = `
    <div class="container">
      <h1 class="title">404 - This page does not exist</h1>
      <button class="button is-primary" onclick="window.location.href = '/app/me/user-accounts'">Go to home page</button>
    </div>
  `

  document.querySelector('header-authenticated').innerHTML = ''
}
